import {
  FETCH_FUNCTION_TEMPLATES_FOR_TEMPLATE_ID_ERROR,
  FETCH_FUNCTION_TEMPLATES_FOR_TEMPLATE_ID_REQUEST,
  FETCH_FUNCTION_TEMPLATES_FOR_TEMPLATE_ID_SUCCESS,
} from "../actions";

import { FunctionTemplatesActions } from "../actionCreators";
import { SByTemplateId } from "./types";

import forTemplateIdReducer from "./forTemplateId";

const initialState: SByTemplateId = {};

const byTemplateIdReducer = (
  state = initialState,
  action: FunctionTemplatesActions
): SByTemplateId => {
  switch (action.type) {
    case FETCH_FUNCTION_TEMPLATES_FOR_TEMPLATE_ID_REQUEST:
    case FETCH_FUNCTION_TEMPLATES_FOR_TEMPLATE_ID_SUCCESS:
    case FETCH_FUNCTION_TEMPLATES_FOR_TEMPLATE_ID_ERROR:
      // tenhle lint problem zmizí s ts immer
      // eslint-disable-next-line
      const { templateId } = action.payload;

      return {
        ...state,
        [templateId]: forTemplateIdReducer(state[templateId], action),
      };

    default:
      return state;
  }
};

export default byTemplateIdReducer;
